import {useInputMenuContext} from 'context/InputMenu';
import {inputMenuActionType, type ModalDialogProps} from 'interfaces';
import {type FC} from 'react';

export const useModalWindow = () => {
  const inputMenuDispatch = useInputMenuContext()?.dispatch;

  const openModalWindow = <T, J>(
    component: FC<ModalDialogProps<T, J>>,
    data?: {
      payload?: J;
      onClose?: (entity: T) => void;
    },
  ) => {
    if (inputMenuDispatch) {
      inputMenuDispatch({
        type: inputMenuActionType.openModalWindow,
        modalWindow: {
          component,
          payload: data?.payload,
          onClose: data?.onClose,
        },
      });
    }
  };
  const closeModalWindow = () => {
    if (inputMenuDispatch) {
      inputMenuDispatch({
        type: inputMenuActionType.closeModalWindow,
      });
    }
  };

  return {
    openModalWindow,
    closeModalWindow,
  };
};
